import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export { translate } from "@/i18n";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(
  iso: string | null | undefined,
  dir: "ltr" | "rtl",
) {
  if (!iso) return "";
  return new Date(iso).toLocaleString(dir === "rtl" ? "ar-EH" : "en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Backend errors follow the remote-service envelope:
// { error: { code, message, details, validationErrors } }
export function getErrorMessage(error: unknown): string | undefined {
  return (error as any)?.response?.data?.error?.message;
}

export function getErrorCode(error: unknown): string | undefined {
  return (error as any)?.response?.data?.error?.code;
}

export function stripHtml(value: string): string {
  if (!value) return "";
  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    return value
      .replace(/<\s*br\s*\/?>/gi, "\n")
      .replace(/<\/(p|div|li|h[1-6])>/gi, "\n")
      .replace(/<[^>]*>/g, "")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  }
  const doc = new DOMParser().parseFromString(value, "text/html");
  doc.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
  doc
    .querySelectorAll("p, div, li, h1, h2, h3, h4, h5, h6")
    .forEach((el) => el.append("\n"));
  return (doc.body.textContent ?? "").replace(/\n{3,}/g, "\n\n").trim();
}
